import { render } from "./TestBox.vue?vue&type=template&id=2b6794da&ts=true"
import script from "./TestBox.vue?vue&type=script&lang=ts"
export * from "./TestBox.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__